import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SelectBox from '../components/SelectBox';
import {
  MapOptionType,
  LocationFilterSizeType,
  LocationFilterType,
  SelectOptionType,
} from '../utils/Types';
import { DEFAULT_OPTION_LOCATION } from '../utils/Constant';
import {
  fetchVillagesOfDistricts,
  locationFilterSelector,
} from '../features/locationFilterSlice';
import { useAppDispatch, useAppSelector } from '../store/redux-hooks';

interface ITrackLocationFilterProps {
  filterData: LocationFilterType;
  setLocationFilter: (filterData: LocationFilterType) => void;
  size?: LocationFilterSizeType;
  hideCity?: boolean;
  hideDistrict?: boolean;
  labelNames?: any;
}

const LocationFilter: React.FunctionComponent<ITrackLocationFilterProps> = ({
  filterData,
  setLocationFilter,
  size,
  hideCity,
  hideDistrict,
  labelNames,
}) => {
  const dispatch = useAppDispatch();
  const [stateOption, setStateOption] = useState<SelectOptionType[]>([]);
  const districtData: MapOptionType = useAppSelector(
    locationFilterSelector
  ).districtData;
  const cityData: MapOptionType = useAppSelector(
    locationFilterSelector
  ).cityOptions;
  const allStates: MapOptionType = useAppSelector(
    locationFilterSelector
  ).statesData;
  const zoneOptionRaw: SelectOptionType[] = useAppSelector(
    locationFilterSelector
  ).zoneOptions;

  const zoneOptions =
    zoneOptionRaw && zoneOptionRaw.length > 1
      ? [DEFAULT_OPTION_LOCATION, ...zoneOptionRaw]
      : zoneOptionRaw;

  const setStateData = (array: SelectOptionType[]) => {
    if (array && array.length === 1) {
      setStateOption(array);
    } else {
      setStateOption([DEFAULT_OPTION_LOCATION, ...(array || [])]);
    }
  };

  const onZoneChange = (event: any) => {
    setLocationFilter({
      ...filterData,
      zone: event,
      state: DEFAULT_OPTION_LOCATION,
      district: DEFAULT_OPTION_LOCATION,
      city: DEFAULT_OPTION_LOCATION,
    });
    setStateData(event?.value ? allStates[event.value] : []);
  };
  const onStateChange = (event: any) => {
    setLocationFilter({
      ...filterData,
      zone:
        zoneOptions.length === 1 &&
        filterData.zone.value !== zoneOptions[0].value
          ? zoneOptions[0]
          : filterData.zone,
      state: event,
      district: DEFAULT_OPTION_LOCATION,
      city: DEFAULT_OPTION_LOCATION,
    });
  };
  const onDistrictChange = (event: any) => {
    setLocationFilter({
      ...filterData,
      district: event,
      city: DEFAULT_OPTION_LOCATION,
    });
    if (event?.value) {
      if (!cityData[event.value]) {
        dispatch(
          fetchVillagesOfDistricts({
            districtId: [Number(event.value)],
          })
        );
      }
    }
  };
  useEffect(() => {
    if (zoneOptions && zoneOptions.length === 1) {
      onZoneChange(zoneOptions[0]);
    }
  }, [zoneOptions]);
  useEffect(() => {
    setStateData(
      filterData?.zone?.value ? allStates[filterData.zone.value] : []
    );
  }, [filterData?.zone]);
  useEffect(() => {
    if (stateOption && stateOption.length === 1) {
      onStateChange(stateOption[0]);
    }
  }, [stateOption, filterData.state]);

  return (
    <Row>
      <Col xs={size?.zone?.xs ?? 6} md={size?.zone?.md ?? 2}>
        <SelectBox
          label={labelNames?.zone || 'Filter By Zone'}
          placeholder={labelNames?.zone || 'Filter By Zone'}
          options={zoneOptions || []}
          className="css-select-bg"
          value={filterData.zone ?? ''}
          onChange={onZoneChange}
          showClear={false}
        />
      </Col>
      <Col xs={size?.zone?.xs ?? 6} md={size?.zone?.md ?? 4}>
        <SelectBox
          label={labelNames?.state || 'Filter By State'}
          placeholder={labelNames?.state || 'Filter By State'}
          options={stateOption}
          className="css-select-bg"
          value={filterData.state ?? DEFAULT_OPTION_LOCATION}
          onChange={onStateChange}
          showClear={false}
        />
      </Col>
      {!hideDistrict && (
        <Col xs={size?.zone?.xs ?? 6} md={size?.zone?.md ?? 2}>
          <SelectBox
            label={labelNames?.district || 'Filter By District'}
            placeholder={labelNames?.district || 'Filter By District'}
            options={[
              DEFAULT_OPTION_LOCATION,
              ...(districtData?.[filterData?.state?.value] ?? []),
            ]}
            className="css-select-bg"
            value={filterData.district ?? DEFAULT_OPTION_LOCATION}
            onChange={onDistrictChange}
            showClear={false}
          />
        </Col>
      )}
      {!hideCity && (
        <Col xs={size?.zone?.xs ?? 6} md={size?.zone?.md ?? 2}>
          <SelectBox
            label={labelNames?.city || 'Filter By City'}
            placeholder={labelNames?.city || 'Filter By City'}
            options={[
              DEFAULT_OPTION_LOCATION,
              ...(cityData?.[filterData?.district?.value ?? -1] ?? []),
            ]}
            className="css-select-bg"
            value={filterData.city ?? DEFAULT_OPTION_LOCATION}
            showClear={false}
            onChange={(event: any) => {
              setLocationFilter({
                ...filterData,
                city: event,
              });
            }}
          />
        </Col>
      )}
    </Row>
  );
};

export default LocationFilter;
